import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Search } from "lucide-react";

const CATS = ["All", "AI Software", "Network Tools", "Computer Software", "Digital Products"];

export default function Catalog() {
  const [products, setProducts] = useState([]);
  const [params, setParams] = useSearchParams();
  const active = params.get("category") || "All";
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);

  const setCat = (c) => { if (c === "All") setParams({}); else setParams({ category: c }); };

  const filtered = products.filter((p) =>
    (active === "All" || p.category === active) &&
    (p.title.toLowerCase().includes(q.toLowerCase()) || p.tagline.toLowerCase().includes(q.toLowerCase())));

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <div className="mb-10">
        <span className="text-xs font-mono uppercase tracking-widest text-cyan-400">Software Catalog</span>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mt-2">Digital Software Products</h1>
        <p className="text-slate-400 mt-3 max-w-2xl">Professional licences delivered instantly via secure download after confirmed payment.</p>
      </div>

      <div className="flex flex-col md:flex-row gap-4 md:items-center justify-between mb-10">
        <div className="flex flex-wrap gap-2">
          {CATS.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`filter-${c.toLowerCase().replace(/[^a-z]/g, "")}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                active === c ? "bg-[#2563EB] text-white" : "bg-[#111C30] text-slate-300 border border-[#1E2F4D] hover:border-[#2563EB]"
              }`}>
              {c}
            </button>
          ))}
        </div>
        <div className="relative w-full md:w-72">
          <Search className="w-4 h-4 text-slate-500 absolute left-3 top-1/2 -translate-y-1/2" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search software..."
            data-testid="catalog-search-input"
            className="w-full bg-[#111C30] border border-[#1E2F4D] rounded-full pl-10 pr-4 py-2.5 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-[#2563EB]" />
        </div>
      </div>

      {filtered.length === 0 ? (
        <p className="text-slate-400 py-20 text-center" data-testid="no-products">No products match your search.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-testid="catalog-grid">
          {filtered.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
